import PropTypes from 'prop-types';
import React from 'react';
import CornerMark from './CornerMark';

const propTypes = {
  direction: PropTypes.oneOf(['topleft', 'topright']),
};

const defaultProps = {
  direction: 'topleft',
};

function WarningMark({
  direction,
}) {
  return (
    <CornerMark icon="alert" kind="warning" direction={direction} />
  );
}

WarningMark.propTypes = propTypes;
WarningMark.defaultProps = defaultProps;


export default (WarningMark);
